import camelCase from 'camelcase'

export const group = (
  label: string,
  fields: any[] = [],
  name: string = camelCase(label),
  description: string = '',
  rawJson: boolean = false
) => ({
  component: 'group',
  label,
  name: rawJson ? `rawJson.${name}` : name,
  description,
  fields
})
